module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }